module.exports = __webpack_public_path__ + "static/media/ramones_thumb_home.7bc497c5.jpg";